import moment from 'moment';
import { TRIAL_EXPIRING_SOON_DAYS } from '../types/company';

const STORAGE_KEY_PREFIX = 'trialEndingModalShown';

export const getTrialEndingStorageKey = (companyId) => {
  const today = moment().format('YYYY-MM-DD');
  return `${STORAGE_KEY_PREFIX}_${companyId || 'default'}_${today}`;
};

export const wasTrialEndingModalShownToday = (companyId) => {
  try {
    return localStorage.getItem(getTrialEndingStorageKey(companyId)) === 'true';
  } catch {
    return false;
  }
};

export const markTrialEndingModalShownToday = (companyId) => {
  try {
    localStorage.setItem(getTrialEndingStorageKey(companyId), 'true');
  } catch {
    // localStorage indisponível
  }
};

/**
 * Decide se deve exibir o modal de trial acabando com base em user.trial.
 * Usa user.trial.daysLeft (campo do SerializeUser) como fonte de verdade.
 *
 * @param {import('../types/company').TrialInfo} trial - user.trial vindo do /auth/me
 * @returns {boolean}
 */
export const shouldShowTrialEndingModal = (trial) => {
  if (!trial || !trial.active) return false;
  const daysLeft = typeof trial.daysLeft === 'number' ? trial.daysLeft : 0;
  return daysLeft <= TRIAL_EXPIRING_SOON_DAYS;
};

/**
 * Fallback para quando o backend ainda não envia user.trial.
 * Mantido durante a transição — remover após migração completa do backend.
 *
 * @deprecated Use shouldShowTrialEndingModal(user.trial) quando o backend estiver atualizado.
 */
export const shouldShowTrialEndingModalLegacy = (dueDate, trialDays = 0) => {
  if (!dueDate) return false;
  const due = moment(dueDate).endOf('day');
  const now = moment();
  if (due.isBefore(now)) return false;
  const daysLeft = due.diff(now, 'days');
  const threshold = trialDays > 0 && trialDays <= 3 ? 1 : 3;
  return daysLeft <= threshold;
};
